/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReserveTripMapDriverCancels
 */
export interface ReserveTripMapDriverCancels {
    /**
     * 
     * @type {number}
     * @memberof ReserveTripMapDriverCancels
     */
    carRequestId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapDriverCancels
     */
    ts?: string;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapDriverCancels
     */
    locCoords?: string;
}

export function ReserveTripMapDriverCancelsFromJSON(json: any): ReserveTripMapDriverCancels {
    return ReserveTripMapDriverCancelsFromJSONTyped(json, false);
}

export function ReserveTripMapDriverCancelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripMapDriverCancels {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carRequestId': !exists(json, 'car_request_id') ? undefined : json['car_request_id'],
        'ts': !exists(json, 'ts') ? undefined : json['ts'],
        'locCoords': !exists(json, 'loc_coords') ? undefined : json['loc_coords'],
    };
}

export function ReserveTripMapDriverCancelsToJSON(value?: ReserveTripMapDriverCancels | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'car_request_id': value.carRequestId,
        'ts': value.ts,
        'loc_coords': value.locCoords,
    };
}


